import React from "react";
import { Link } from "react-router-dom";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";

const TermsOfService: React.FC = () => {
  return (
    <LegalPageLayout
      title="Terms of Service"
      description="Terms and conditions for using Setgo Innovations, Digistore Pay, SetGo Edutech, and Easy Jobs."
    >
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">
        Terms of Service
      </h1>
      <p className="text-secondary-600 text-sm mb-8">
        Last updated: January 2025. Setgo Innovations Private Limited (CIN:
        U85499KL2025PTC092559).
      </p>

      <section className="space-y-6 text-secondary-700">
        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using any service provided by Setgo Innovations
            Private Limited (“we”, “us”, “our”) — including Digistore Pay
            (Fintech), SetGo (Edutech), Easy Jobs (Jobtech), our websites, apps,
            payment solutions, learning platforms, and job-matching services —
            you agree to these Terms of Service. If you do not agree, do not use
            our services.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            2. Eligibility
          </h2>
          <p>
            You must be at least 18 years old and legally capable of entering
            into a binding contract to use our services. For Digistore Pay
            partner registration, you must meet our eligibility criteria and
            provide accurate business and identity information. Use of our
            services from India is subject to Indian law.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            3. Use of Services
          </h2>
          <p className="mb-2">You agree to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Provide accurate and complete information when registering or
              transacting (e.g. partner registration, learner enrolment, job
              applications).
            </li>
            <li>
              Use Digistore Pay, SetGo, and Easy Jobs only for lawful purposes
              and in compliance with applicable laws, including RBI and
              financial regulations.
            </li>
            <li>
              Not misuse our platforms for fraud, money laundering, or any
              illegal activity.
            </li>
            <li>
              Not share your account credentials or allow others to use your
              account without our consent.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            4. Digistore Pay (Fintech)
          </h2>
          <p>
            Digistore Pay provides digital payment and shop digitalization
            solutions. Use of payment features is subject to our payment
            partner terms (e.g. Razorpay) and applicable banking and RBI
            guidelines. You are responsible for the accuracy of transaction
            details and for any fees or charges disclosed at the time of use.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            5. SetGo (Edutech) and Easy Jobs (Jobtech)
          </h2>
          <p>
            SetGo offers skill-based learning, internships, and training
            programs. Easy Jobs connects talent with employers and may involve
            digital payouts and work allocation. Your use of these services is
            subject to any additional terms or agreements provided at
            enrolment or sign-up.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            6. Intellectual Property
          </h2>
          <p>
            All content, logos, software, and materials on our platforms are
            owned by Setgo Innovations or our licensors. You may not copy,
            modify, or distribute our intellectual property without written
            permission.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            7. Limitation of Liability
          </h2>
          <p>
            To the extent permitted by law, we are not liable for indirect,
            incidental, or consequential damages arising from your use of our
            services. Our liability is limited to the amount you paid us in the
            twelve months preceding the claim, or as otherwise required by
            applicable Indian law.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            8. Termination
          </h2>
          <p>
            We may suspend or terminate your access to our services if you
            breach these terms or for operational or legal reasons. You may
            stop using our services at any time. Provisions that by their
            nature should survive (e.g. liability, dispute resolution) will
            survive termination.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            9. Governing Law and Disputes
          </h2>
          <p>
            These terms are governed by the laws of India. Any disputes shall
            be subject to the exclusive jurisdiction of the courts in Kerala,
            India. We are headquartered in Kerala, India; CIN:
            U85499KL2025PTC092559.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            10. Contact
          </h2>
          <p>
            For questions about these Terms of Service, contact us at{" "}
            <a
              href="mailto:contact@setgo.in"
              className="text-primary-500 hover:underline"
            >
              contact@setgo.in
            </a>
            . Setgo Innovations Private Limited, headquartered in Kerala, India.
          </p>
        </div>
      </section>

      <p className="mt-10 text-sm text-secondary-500">
        <Link to="/" className="text-primary-500 hover:underline">
          ← Back to home
        </Link>
      </p>
    </LegalPageLayout>
  );
};

export default TermsOfService;
